import { CreatePageMeta, CreatePagePayload } from 'types/store/CreatePageState';
import { createAsyncReducer } from 'utils/Redux';

import { createPageActions } from '../actions';

export default createAsyncReducer<CreatePageMeta, CreatePagePayload>(
  createPageActions
);
